import React, { useCallback, useState } from "react";
import { useDropzone } from "react-dropzone";
import { useSelector } from "react-redux";
import * as XLSX from "xlsx";
import * as Yup from "yup";
import { Row, Col } from "react-bootstrap";
import InternetChecking from "../../Student/Reusablecomponents/Network";
import Loading from "../../Student/Reusablecomponents/Loading";
import { LuDownload } from "react-icons/lu";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { FaTrash, FaEdit } from "react-icons/fa"; // Font Awesome
import notify from "../../ReusableComponents/ToastifyAlerts";
const AutobulkRegistrations = () => {
  const navigate = useNavigate();
  const [Load, SetLoad] = useState(false);
  const [ValidRecords, setValidRecordsData] = useState([]);
  const [InvalidRecords, setInValidRecordsData] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [FirstName, setFirstName] = useState("");
  const [LastName, setLastName] = useState("");
  const [DOB, setDOB] = useState("");
 
  const [Gender, setGender] = useState("");
  const [Grade, setGrade] = useState("");
  const [ElectiveSubject, setElectiveSubject] = useState("");
  const [OptionalSubject, SetOptionalSubject] = useState("");
  const [isElectiveEnabled, setIsElectiveEnabled] = useState(false);
  const [Section, setSection] = useState("");
  const [isValid, setIsValid] = useState(true);
  const [errors, setErrors] = useState({});
  const [todayDate, setDate] = useState("");
  const [RecordExitsInDb, setRecordExitsInDb] = useState("");
  const [leapyear, setleapyear] = useState("");
  const [selectedDeleteIds, setselectedDeleteIds] = useState([]);
  const [selectedValidDeleteIds, setselectedvalidDeleteIds] = useState([]);
  const [MediumofInstruction, setMediumofInstruction] = useState("");
  const [PSTStatus, SetPSTStatus] = useState("");

  const items = useSelector((state) => state.userDetailsData.LoginDetails);

  const schoolId = useSelector(
    (state) => state.userDetailsData.LoginDetails.schoolId
  );
  //Compare Validate the Excel Sheet Header
  const validateHeader = (headerRow, expectedHeader) => {
    return JSON.stringify(headerRow) === JSON.stringify(expectedHeader);
  };
  //Excel header Details
  const expectedHeader = [
    "SNo",
    "First Name",
    "Last Name",
    "DOB",
    "Gender",
    "Grade",
    "Section",
    "Language",
    "Elective Subject",
    "Medium of Instruction",
    ...(items?.societyName === "NATCO" ? ["PST Status"] : [])
  ];
  //Checking File Type
  const onDrop = useCallback((acceptedFiles, rejectedFiles) => {
    if (rejectedFiles.length > 0) {
      alert("Only .xls and .xlsx files are allowed");
      return;
    }
    const file = acceptedFiles[0];
    const reader = new FileReader();

    // Function to validate a row
    const validateRow = async (row) => {
      try {
        await validationSchema.validate(row, { abortEarly: false });
        return { isValid: true, errors: {}, RecordExitsInDb: 0 };
      } catch (err) {
        const errors = err.inner.reduce((acc, error) => {
          return { ...acc, [error.path]: error.message };
        }, {});
        return { isValid: false, errors, RecordExitsInDb: 0 };
      }
    };

    //Checking the Student alredy exits or not
    //Bind the valid and Invalid Data Tables
    const processExcelData = async (jsonData) => {
      SetLoad((prev) => !prev);
      const validatedData = await Promise.all(
        jsonData.map(async (row) => {
          const validation = await validateRow(row);
          if (validation.isValid === true) {
            await axios
              .get(
                process.env.REACT_APP_API_BASE_URL +
                `/School/IsStudentExists?FirstName=${row.FirstName}&LastName=${row.LastName}&DateOfBirth=${row.DOB}&Grade=${row.Grade}&Gender=${row.Gender}&schoolId=${schoolId}`,
                { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
              )
              .then((res) => {
                if (res.data !== 0) {
                  const Stuid = res.data;
                  validation.isValid = false;
                  validation.RecordExitsInDb = 1;
                  if (res.data > 2) {
                    validation.errors.DuplicateRec = `Record already exists (Student Id: ${Stuid})`;
                    setleapyear("0");
                  } else {
                    //Leaf yearcheck
                    validation.errors.DuplicateRec = `Invalid date value`;
                    setleapyear("1");
                  }
                } else {

                  const validElectiveSubjects = ["Mathematics", "Biology"];
                  const validOptionalSubjects = items.languageSubjectName.split(",").map((Sub) => Sub.trim());
                  const ValidMediumSubjects = items.medium.split(",").map((M) => M.trim());
                  if (row.MediumofInstruction && !ValidMediumSubjects.includes(row.MediumofInstruction)) {
                    validation.isValid = false;
                    validation.errors.MediumofInstruction = "In valid Medium of instruction";
                  } else if (!row.MediumofInstruction) {
                    validation.isValid = false;
                    validation.errors.MediumofInstruction = "Medium of instruction is required";
                  }
                  if (parseInt(row.Grade) <= 10 && (row.OptionalSubject === "" || row.OptionalSubject === null)) {
                    validation.isValid = false;
                    validation.errors.OptionalSubject = "Language is required";
                  } else if (parseInt(row.Grade) <= 10 && validOptionalSubjects.includes(row.OptionalSubject) === false) {
                    validation.isValid = false;
                    validation.errors.OptionalSubject = " Invalid Language";
                  }
                  else if (row.Grade > 10 && validOptionalSubjects.includes(row.OptionalSubject) === true) {
                    validation.isValid = false;
                    validation.errors.OptionalSubject = "Language is not required";
                  }

                  if (
                    row.Grade > 10 &&
                    (row.ElectiveSubject === "" || row.ElectiveSubject === null)
                  ) {
                    validation.isValid = false;
                    validation.errors.ElectiveSubject =
                      "Elective Subject is required";
                  } else if (
                    row.Grade > 10 &&
                    validElectiveSubjects.includes(row.ElectiveSubject) ===
                    false
                  ) {
                    validation.isValid = false;
                    validation.errors.ElectiveSubject =
                      "Invalid Elective Subject allow Mathematics,Biology";
                  }
                  validation.RecordExitsInDb = 0;
                }
              });
          }
          return {
            ...row,
            isValid: validation.isValid,
            errors: validation.errors,
            RecordExitsInDb: validation.RecordExitsInDb,
          };
        })
      );
      const Finallistdetails = [];
      validatedData.map(async (element) => {
        const RecordExitinArrya = Finallistdetails.some(
          (a) =>
            a.FirstName.trim().toLowerCase() === element.FirstName.trim().toLowerCase() &&
            a.LastName.trim().toLowerCase() === element.LastName.trim().toLowerCase() &&
            a.Gender.trim().toLowerCase() === element.Gender.trim().toLowerCase() &&
            a.Grade === element.Grade &&
            a.DOB === element.DOB &&
            a.Section.trim().toLowerCase() === element.Section.trim().toLowerCase()
            && a.MediumofInstruction === element.MediumofInstruction
            // && (items?.societyName === "NATCO" &&
            //   a["PST Status"] === element["PST Status"])
        );
        console.log("RecordExitinArrya",RecordExitinArrya)
        if (RecordExitinArrya === true) {
          element.isValid = false;
          element.errors.DuplicateRec = "Duplicate Entry";
          element.RecordExitsInDb = 1;
        }
        Finallistdetails.push(element);
      });
      setValidRecordsData(
        Finallistdetails.filter((row) => row.isValid === true)
      );
      setInValidRecordsData(
        Finallistdetails.filter((row) => row.isValid === false)
      );
    };

    const excelDateToJSDate = (serial) => {
      if (typeof serial !== "number" || isNaN(serial)) {
        console.error("Invalid date serial number:", serial);
      }
      const utcStart = new Date(Date.UTC(1899, 11, 30));
      const jsDate = new Date(utcStart.getTime() + serial * 86400000);
      if (isNaN(jsDate.getTime())) {
        return null;
      }
      return jsDate;
    };

    //Date Formate
    const formatDate = (date) => {
      if (!date || isNaN(date.getTime())) {
        return "Invalid Date";
      }

      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      return `${year}-${month}-${day}`;
    };

    const getTodayDate = () => {
      const today = new Date();
      const day = String(today.getDate()).padStart(2, "0");
      const month = String(today.getMonth() + 1).padStart(2, "0"); // January is 0
      const year = today.getFullYear();
      return `${year}-${month}-${day}`;
    };
    setDate(getTodayDate());
    reader.onload = async (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const headers = XLSX.utils.sheet_to_json(worksheet, { header: 1 })[0];
      const isHeaderValid = validateHeader(headers, expectedHeader);
      if (!isHeaderValid) {
        alert(
          "Invalid header in Excel file. Please check the file and try again."
        );
        return;
      }
      const jsonData = XLSX.utils.sheet_to_json(worksheet);
      let currentYear = new Date().getFullYear();
      const ValidResultArray = [];
      if (jsonData.length > 0) {
        jsonData.forEach((element) => {
          //  const jsDate = excelDateToJSDate(element.DOB);
          //  const formattedDate = formatDate(jsDate);
          //  element.DOB = formattedDate
          let Exdob = element.DOB;
          if (element.DOB) {
            if (typeof Exdob === "number") {
              const jsDate = excelDateToJSDate(Exdob);
              const formattedDate = formatDate(jsDate);
              element.DOB = formattedDate;
            } else if (Exdob.includes("/") === true) {
              const dobparts = Exdob.split("/");
              const count = dobparts.length;
              const DOB =
                count === 3
                  ? dobparts[2].length === 4 &&
                    dobparts[2] <= currentYear &&
                    dobparts[1].length <= 2 &&
                    dobparts[1] <= 12 &&
                    dobparts[0].length <= 2 &&
                    dobparts[0] <= 31
                    ? `${dobparts[2]}-${dobparts[1]}-${dobparts[0]}`
                    : element.DOB
                  : "0000/00/00";
              element.DOB = DOB;
            } else if (Exdob.includes("-") === true) {
              const dobparts = Exdob.split("-");
              const count = dobparts.length;
              const DOB =
                count === 3
                  ? dobparts[2].length === 4 &&
                    dobparts[2] <= currentYear &&
                    dobparts[1].length <= 2 &&
                    dobparts[1] <= 12 &&
                    dobparts[0].length <= 2 &&
                    dobparts[0] <= 31
                    ? `${dobparts[2]}-${dobparts[1]}-${dobparts[0]}`
                    : element.DOB
                  : "0000/00/00";
              element.DOB = DOB;
            } else {
              element.DOB = element.DOB;
            }
          } else {
            element.DOB = element.DOB;
          }
          let TGender =
            element.Gender !== undefined
              ? String(element.Gender).replace(/\s+/g, "")
              : "";
          let TGrade =
            element.Grade !== undefined
              ? String(element.Grade).replace(/\s+/g, "")
              : "0";
          let TSection =
            element.Section !== undefined
              ? String(element.Section).replace(/\s+/g, "")
              : "";
          let TFirstName =
            element.FirstName !== "" ? element["First Name"] : null;
          let TPSTStatus = items?.societyName === "NATCO"
            ? element["PST Status"]
            : "";

          let TLastName = element.LastName !== "" ? element["Last Name"] : null;
          let TElectiveSubject = String(element["Elective Subject"] || "");
          let TOptionalSubject = String(element["Language"] || "");

          let TMediumofInstruction =
            element.MediumofInstruction !== ""
              ? element["Medium of Instruction"]
              : null;
          element.PSTStatus = TPSTStatus !== undefined ? TPSTStatus : ""
          element.Gender =
            TGender.trim() === "M" ||
              TGender.trim() === "F" ||
              TGender.trim() === "O"
              ? TGender.trim()
              : null;
          element.Grade =
            parseInt(TGrade.trim(), 10) >= 1 &&
              parseInt(TGrade.trim(), 10) <= 12
              ? TGrade.trim()
              : 0;
          element.Section =
          items.section?.split(",").map((SEC)=>SEC.trim()).includes(TSection.trim())
            // TSection.trim() === "A" ||
            //   TSection.trim() === "B" ||
            //   TSection.trim() === "C" ||
            //   TSection.trim() === "D"
              ? TSection
              : null;
          element.FirstName =
            TFirstName !== undefined ? TFirstName.toString().trim() : null;
          element.LastName =
            TLastName !== undefined ? TLastName.toString().trim() : null;
          element.MediumofInstruction =
            TMediumofInstruction !== undefined
              ? TMediumofInstruction.trim()
              : null;
          element.ElectiveSubject =
            TElectiveSubject !== undefined
              ? TGrade > 10
                ? TElectiveSubject.trim() === "Biology" ||
                  // TElectiveSubject.trim() === "BT" ||
                  TElectiveSubject.trim() === "Mathematics"
                  ? TElectiveSubject.trim()
                  : null
                : null
              : null;
          element.OptionalSubject = TOptionalSubject !== undefined

            ? (TGrade <= 10)
              ? TOptionalSubject.trim() === "Telugu" ||
                TOptionalSubject.trim() === "Hindi"
                ? TOptionalSubject.trim()
                : null
              : null
            : null;
          if (
            element.FirstName !== null ||
            element.LastName !== null ||
            element.Grade !== "0" ||
            element.Gender !== "" ||
            element.DOB !== "" ||
            element.Section !== ""
            // || element.MediumofInstruction !== ""
          ) {
            ValidResultArray.push(element);
          }
        });
      }
      await processExcelData(ValidResultArray);
      SetLoad((prev) => !prev);
      // Clear the workbook and worksheet data
      workbook.SheetNames = [];
      workbook.Sheets = {}; // This clears the actual sheet data
    };
    reader.readAsArrayBuffer(file);
  }, []);
  //Excel Mime types checking
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: {
      "application/vnd.ms-excel": [".xls"],
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [
        ".xlsx",
      ],
    },
    multiple: false,
  });
  //While Update the Error record Checking validation Points
  const validationSchema = Yup.object().shape({
    FirstName: Yup.string()
      .matches(/^[A-Za-z\s]*$/, "Invalid First Name")
      .required("First Name is required")
      .nullable()
      .test(
        "is-defined",
        "First Name is required",
        (value) => value !== undefined && value !== null && value !== ""
      ),

    LastName: Yup.string()
      .matches(/^[A-Za-z\s]*$/, "Invalid Last Name")
      //.required("Last Name is required")
      .nullable()
      .test("no-special-char-only", "Invalid Last Name", (value) => {
        if (value === null || value === "") return true;
        return /[A-Za-z]/.test(value);
      }),

    DOB: Yup.string()
      .required("Date of Birth is required")
      .test(
        "is-valid-date",
        ({ value }) => `Invalid DOB(${value})`,
        (value) => {
          if (!value || isNaN(Date.parse(value))) {
            return false;
          }
          const dateValue = new Date(value);
          const today = new Date();
          if (dateValue.getFullYear() === 0 || dateValue > today) {
            return false;
          }
          return true;
        }
      ),
    Gender: Yup.string()
      .required("Gender is required")
      .nullable()
      .oneOf(["M", "F", "O"], ({ value }) => `Invalid Gender(${value})`)

      .test(
        "is-defined",
        "Gender is required",
        (value) => value !== undefined && value !== null
      ),
    //Grade: Yup.number().required("Grade is required"),

    Grade: Yup.number()
      .required("Grade is required")
      .oneOf(
        [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        ({ value }) => `Invalid Grade(${value})`
      )
      .nullable()
      .test(
        "is-defined",
        "Grade is required",
        (value) => value !== undefined && value !== null
      ),

    Section: Yup.string()
      .required("Section is required")
      .oneOf(items.section?.split(",").map((SEC)=>SEC.trim()), ({ value }) => `Invalid Section:(${value})`)
      .nullable()
      .test(
        "is-defined",
        "Section is required",
        (value) => value !== undefined && value !== null
      ),

    MediumofInstruction: Yup.string().required("Medium is required"),

    OptionalSubject: Yup.string().when("Grade", {
      is: (grade) => Number(grade) <= 10,
      then: () => Yup.string().required("Language is required"),
      otherwise: () => Yup.string().notRequired(),
    }),
    PSTStatus: Yup.string().when("items", {
      is: () => (items.societyName === "NATCO"),
      then: () => Yup.string().required("Invalid PST Status")
        .oneOf(["Yes", "No"], "Invalid PST Status"),
      otherwise: () => Yup.string().notRequired(),
    }),

  });
  //Edit Click Data
  const handleEditClick = (
    id,
    FirstName,
    LastName,
    DOB,
    Gender,
    Grade,
    Section,
    ElectiveSubject,
    MediumofInstruction,
    OptionalSubject,
    PSTStatus,
  ) => {
    setErrors("");
    setEditingId(id);
    setFirstName(FirstName);
    setLastName(LastName);
    setDOB(DOB);
    setGender(Gender);
    setGrade(Grade);
    setSection(Section);
    setElectiveSubject(ElectiveSubject);
    setMediumofInstruction(MediumofInstruction);
    setIsElectiveEnabled("None");
    SetOptionalSubject(OptionalSubject);
    SetPSTStatus(PSTStatus);
  };
  // Save the  update Records
  const handleSaveClick = async (id) => {
    if (Grade > 10 && (ElectiveSubject === null || ElectiveSubject === "")) {

      setErrors({ ...errors, ElectiveSubject: "Elective Subject is required" });
      // alert("Please select Elective Subject");
      return false;
    }
    if (Grade <= 10 && (OptionalSubject === null || OptionalSubject === "")) {
      setErrors({ ...errors, Language: "Language is required" });

      // alert("Please select Language");
      return false;
    }
    const matchingRecords = ValidRecords.filter(
      (record) =>
        record.FirstName === FirstName &&
        record.LastName === LastName &&
        record.DOB === DOB &&
        record.Grade === Grade &&
        record.Gender === Gender
    );
    if (matchingRecords.length !== 0) {
      alert("Duplicate entry found. Please check and update.");
    } else {
      try {
        await validationSchema.validate(
          {
            FirstName,
            LastName,
            DOB,
            Gender,
            Grade,
            Section,
            ElectiveSubject,
            MediumofInstruction,
            OptionalSubject,
            PSTStatus,
          },
          { abortEarly: false }
        );
        // Find the record that needs to be updated
        const updatedRecord = InvalidRecords.find(
          (_, index) => index + 1 === id
        );
        await axios
          .get(
            process.env.REACT_APP_API_BASE_URL +
            `/School/IsStudentExists?FirstName=${FirstName}&LastName=${LastName}&DateOfBirth=${DOB}&Grade=${Grade}&Gender=${Gender}&schoolId=${schoolId}`,
            // `/School/IsStudentExists?FirstName=${updatedRecord.FirstName}&LastName=${updatedRecord.LastName}&DateOfBirth=${updatedRecord.DOB}&Grade=${updatedRecord.Grade}&Gender=${updatedRecord.Gender}&schoolId=${schoolId}`,
            { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
          )

          .then((res) => {
            if (res.data == 0) {
              // Update the record with the new values
              const newRecord = {
                ...updatedRecord,
                FirstName,
                LastName,
                DOB,
                Gender,
                Grade,
                Section,
                ElectiveSubject,
                MediumofInstruction,
                OptionalSubject,
                PSTStatus,
                isValid: true, // Mark the record as valid
                errors: {}, // Clear errors since the record is now valid
              };
              // Remove the record from invalid records
              const updatedInvalidRecords = InvalidRecords.filter(
                (_, index) => index + 1 !== id
              );
              setInValidRecordsData(updatedInvalidRecords);
              // Add the updated record to valid records
              setValidRecordsData([...ValidRecords, newRecord]);
              // Clear form and reset editing state
              setEditingId(null);
              setFirstName("");
              setLastName("");
              setDOB("");
              setGender("");
              setGrade("");
              setSection("");
              setElectiveSubject("");
              setMediumofInstruction("");
              SetOptionalSubject("");
              SetPSTStatus("");
              setIsValid(true);
              setErrors({});
            } else {
              const newRecord = {
                ...updatedRecord,
                FirstName,
                LastName,
                DOB,
                Gender,
                Grade,
                Section,
                ElectiveSubject,
                MediumofInstruction,
                OptionalSubject,
                PSTStatus,
                RecordExitsInDb: 1,
                isValid: true, // Mark the record as valid
                errors: { DuplicateRec: `Record already exists (Student Id: ${res.data})` }, // Clear errors since the record is now valid
              };

              setInValidRecordsData(InvalidRecords.map((record, index) => index + 1 === id ? newRecord : record));
              setEditingId(null);
            }
          }
          )
          .catch((err) => {
            console.log(err)
          })


      } catch (err) {
        const validationErrors = err.inner.reduce((acc, error) => {
          return { ...acc, [error.path]: error.message };
        }, {});
        setErrors(validationErrors);
        setIsValid(false);
      }
    }
  };
  //Set values the textboxs
  const handleFirstNameChange = (e) => setFirstName(e.target.value);
  const handleLastNameChange = (e) => setLastName(e.target.value);
  const handleDOBChange = (e) => setDOB(e.target.value);
  const handleGenderChange = (e) => setGender(e.target.value);
  const handleGradeChange = (e) => {
    const selectedGrade = e.target.value;
    setGrade(selectedGrade);
    if (selectedGrade > 10) {
      setIsElectiveEnabled("");
    } else {
      setIsElectiveEnabled("None");
      setElectiveSubject(""); // Reset elective subject if grade <= 10
    }
  };

  const handleElectiveSubjectChange = (e) => setElectiveSubject(e.target.value);
  const handleMediumofInstruction = (e) =>
    setMediumofInstruction(e.target.value);
  const handleSectionChange = (e) => setSection(e.target.value);
  const handleOptionalSubjectChange = (e) => SetOptionalSubject(e.target.value);
  const handlePSTStatus = (e) => SetPSTStatus(e.target.value);
  //Saveing Data
  let insertedRecords;
  const FinalSaveValidRecords = async (row) => {
    SetLoad((prev) => !prev);
    insertedRecords = ValidRecords?.map((item) => ({
      schoolId: schoolId,
      firstName: item.FirstName,
      lastName: item.LastName,
      class: item.Grade,
      gender: item.Gender,
      dateOfBirth: item.DOB,
      optionalSubject: item.ElectiveSubject || "",
      section: item.Section,
      MediumofInstruction: item.MediumofInstruction,
      optionalLanguage: item.OptionalSubject || "",
      createdBy: items.userId,
      PSTStatusName: item?.PSTStatus || "",
    }));
    await axios
      .post(
        process.env.REACT_APP_API_BASE_URL + "/School/SaveUploadStudent",
        insertedRecords,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        notify("Records are uploaded successfully", "success");
        // alert("Records are uploaded successfully");
        setValidRecordsData();
        navigate("/TeacherDashboard/StudentInformation/StudentDetails");
      })
      .catch((err) => {
        alert("unable to upload Records");
      });
  };
  const handleDeleteRow = (id, recordType) => {
    const confirmed = window.confirm("Are you sure Delete the record?");
    if (confirmed) {
      if (recordType === "valid") {
        setValidRecordsData(
          ValidRecords.filter((_, index) => index + 1 !== id)
        );
      } else if (recordType === "invalid") {
        setInValidRecordsData(
          InvalidRecords.filter((_, index) => index + 1 !== id)
        );
      }
      alert("Deleted successfully!");
    }
  };

  const handleInvalidSelectRow = (id) => {
    setselectedDeleteIds((prev) =>
      prev.includes(id)
        ? prev.filter((selectedId) => selectedId !== id)
        : [...prev, id]
    );
  };

  const handleValidSelectRow = (id) => {
    setselectedvalidDeleteIds((prev) =>
      prev.includes(id)
        ? prev.filter((selectedId) => selectedId !== id)
        : [...prev, id]
    );
  };

  const handleDeleteRows = (selectedIds, recordType) => {
    if (selectedIds.length === 0) {
      alert("No records selected for deletion.");
      return;
    }
    const confirmed = window.confirm(
      "Are you sure you want to delete the selected records?"
    );
    if (confirmed) {
      if (recordType === "invalid") {
        setInValidRecordsData(
          InvalidRecords.filter((_, index) => !selectedIds.includes(index + 1))
        );
      }
      if (recordType === "valid") {
        setValidRecordsData(
          ValidRecords.filter((_, index) => !selectedIds.includes(index + 1))
        );
      }
      setselectedDeleteIds([]);
      setselectedvalidDeleteIds([]);
      alert("Selected records deleted successfully!");
    }
  };
  // Below Function is for download of the sample Excel File

  const handleCancelClick = (id) => {
    const updatedRecords = [...InvalidRecords];
    setInValidRecordsData(updatedRecords);
    setEditingId(null);
  };
  const DisplayformatDate = (dob) => {
    const date = new Date(dob);
    if (isNaN(date.getTime())) {
      return "00/00/0000";
    }
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };
  const DownloadSamplefile = () => {
    const a = document.createElement("a");
    // a.style.display = 'none';
    if (items?.societyName === "NATCO") {
      a.href = `/BulkUploadTemplets/${items?.societyName}${items.languageSubjectName}${items.medium}.xls`;
    } else {
      a.href = `/BulkUploadTemplets/${items.languageSubjectName}${items.medium}.xls`;
    }
    a.download = "StudentsRegistrationTemplate.xls";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };
  return (
    <>
      <div className="TeacherBgImage dflex flexd-column">
        <InternetChecking />
        <div className="dflex JSBetween">
          <div></div>
          <div className="dflex gap-3">
            <div className="dflex alignitems SampleFiles gap-1 CPointer" onClick={() => DownloadSamplefile()} >
              <LuDownload />Sample Template </div>
          </div></div>
        <div className="container-fluid Card mt-2">
          <Row>
            {/* Below column is for input feilds for the uploading the file */}
            <Col className="Fileupload">
              <div className="Grade-Information">Upload students</div>
              <div
                {...getRootProps()}
                style={{
                  border: "2px dashed #1436a5",
                  padding: "20px",
                  textAlign: "center",
                  cursor: "pointer",
                  borderRadius: "5px",
                  // height: '25px',
                  backgroundColor: isDragActive ? "#e0e7ff" : "#f8f9fa",
                }}
              >
                <input {...getInputProps()} />
                {isDragActive ? (
                  <p>Drop the file here...</p>
                ) : (
                  <p>Select or Drag and drop file</p>
                )}
              </div>
            </Col>
            {/* Below column is for guidelines for format of excel file */}
            <Col>
              <div className="Grade-Information ">Upload instructions</div>
              <ol>
                <li>Download the required template as per the medium of instruction. </li>
                <li>Do not change the header names in the file. </li>
                <li>Rename the filename of the template. </li>
                <li>Save the template in (.xls) file format only. </li>
                <li>Add the students into the downloaded template. </li>
                <li>All fields in the template are mandatory. </li>
                <li>
                  DOB format in excel should be dd-mm-yyyy.(Right click on date
                  column and select format cell [Date : 14-03-2001]){" "}
                </li>
                <li>Gender should be "M", "F" or "O". </li>
                <li>Grade value should be 1 - 12. </li>
                <li>Section value should be A, B, C, D. </li>
                <li> For grades 1 to 10 Language: The values should be Telugu or Hindi. For
                  grades 11-12 leave blank.
                </li>
                <li> For grades 11 and 12 Elective Subject: The values should be Mathematics or Biology. For
                  grades 1 -10 leave blank. Upload the filled template
                </li>
                <li>PST Status value should be Yes or No (applicable for only NATCO schools).</li>
                <li> Upon successful uploading click on “Save" </li>
                <li>
                  Go to Student Information to view the registered students.{" "}
                </li>
                <li className="text-danger">
                  Please do not refresh the page until the final Save is
                  completed.
                </li>
                <li className="text-danger">
                  Elective Subject is required only for Grade 11 and 12. Any
                  elective subject value provide for the grades other than 11
                  and 12 will be ignored.
                </li>
                <li className="text-danger">
                  The records with empty values for First Name and Last Name
                  fields will not be considered for registration
                </li>
              </ol>
            </Col>
          </Row>
        </div>
        <div className="row">
          <div className="col-md-12">
            {InvalidRecords && InvalidRecords.length > 0 && (
              <div className="Table-Card mt-3  " style={{ overflow: "clip" }}>
                <div className="Grade-Information p-3 " style={{ color: "orangered" }} >
                  Invalid Records
                  {selectedDeleteIds && selectedDeleteIds.length > 0 ? (
                    <button onClick={() => handleDeleteRows(selectedDeleteIds, "invalid") }
                      className="btn btn-sm btn-warning" style={{ float: "right", marginLeft: "5px" }}
                    > Delete selected records </button>
                  ) : ( "" )}
                </div>
                <div className="table-responsive">
                  <table className="table table-bordered table-sm" width={100}>
                    <thead>
                      <tr>
                        <th width={5}></th>
                        <th width={5}>S.No</th>
                        <th width={10}>First Name</th>
                        <th width={10}>Last Name</th>
                        <th width={10}>DOB</th>
                        <th width={10}>Gender</th>
                        <th width={10}>Grade</th>
                        <th width={10}>Section</th>
                        <th width={5}>Language</th>
                        <th width={5}>Elective Subject</th>
                        <th width={5}>Medium of Instruction</th>
                        {items?.societyName === "NATCO" && <th width={5}>PST Status</th>}
                        <th width={10}>Error Message</th>
                        <th width={10}>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {InvalidRecords?.map((row, index) => (
                        <React.Fragment key={index + 1}>
                          <tr>
                            <td width={5} style={{ textAlign: "center" }}>
                              <input class="form-check-input" type="checkbox"
                                checked={selectedDeleteIds.includes(index + 1)}
                                onChange={() => handleInvalidSelectRow(index + 1) } />
                            </td>
                            <td style={{ textAlign: "center" }} width={5}> {index + 1} </td>

                            <td>
                              {editingId === index + 1 &&
                                row?.errors.FirstName ? (
                                <>
                                  <input className="form-control border-danger col-md-2" type="text" name="FirstName"
                                    value={FirstName} onChange={handleFirstNameChange} required />
                                  {errors.FirstName && ( <div className="error-message"> {errors.FirstName} </div> )}
                                </>
                              ) : (
                                row.FirstName
                              )}
                            </td>
                            <td>
                              {editingId === index + 1 &&
                                row.errors.LastName ? (
                                <>
                                  <input className="form-control border-danger" type="text" name="LastName"
                                    value={LastName} onChange={handleLastNameChange} required />
                                  {errors.LastName && ( <div className="error-message"> {errors.LastName} </div> )}
                                </>
                              ) : (
                                row.LastName
                              )}
                            </td>
                            <td>
                              {editingId === index + 1 && row.errors.DOB ? (
                                <>
                                  <input
                                    className="form-control border-danger"
                                    type="date"
                                    placeholder="dd-mm-yyyy"
                                    name="DOB"
                                    value={DOB}
                                    onChange={handleDOBChange}
                                    required
                                    max={todayDate}
                                  />
                                  {errors.DOB && (
                                    <div className="error-message">
                                      {errors.DOB}
                                    </div>
                                  )}
                                </>
                              ) :
                                row.DOB !== "0000/00/00" ? (
                                  leapyear == 0 ? (
                                    DisplayformatDate(row.DOB)
                                  ) : (
                                    row.DOB
                                  )
                                ) : (
                                  "yyyy-mm-dd"
                                )}
                            </td>
                            <td style={{ textAlign: "center" }}>
                              {editingId === index + 1 && row.errors.Gender ? (
                                <>
                                  <select
                                    className="form-select border-danger"
                                    name="Gender"
                                    value={Gender}
                                    required
                                    onChange={handleGenderChange}
                                  >
                                    <option value="">Select Gender</option>
                                    <option value="M">Boy(M)</option>
                                    <option value="F">Girl(F)</option>
                                    <option value="O">Other(O)</option>
                                  </select>
                                  {errors.Gender && (<div className="error-message"> {errors.Gender} </div>)}
                                </>
                              ) : (
                                row.Gender
                              )}
                            </td>
                            <td style={{ textAlign: "center" }}>
                              {editingId === index + 1 && row.errors.Grade ? (
                                <>
                                  <select className="form-select border-danger" name="Grade"
                                    value={Grade} required onChange={handleGradeChange} >
                                    <option value="">Select Grade</option>
                                    <option value="1">Grade 1</option>{" "}
                                    <option value="2">Grade 2</option>{" "}
                                    <option value="3">Grade 3</option>{" "}
                                    <option value="4">Grade 4</option>{" "}
                                    <option value="5">Grade 5</option>{" "}
                                    <option value="6">Grade 6</option>
                                    <option value="7">Grade 7</option>
                                    <option value="8">Grade 8</option>
                                    <option value="9">Grade 9</option>
                                    <option value="10">Grade 10</option>
                                    <option value="11">Grade 11</option>
                                    <option value="12">Grade 12</option>
                                  </select>
                                  {errors.Grade && (<div className="error-message"> {errors.Grade} </div>)}
                                </>
                              ) : (
                                row.Grade
                              )}
                            </td>
                            <td style={{ textAlign: "center" }}>
                              {editingId === index + 1 && row.errors.Section ? (
                                <>
                                  <select className="form-select border-danger" name="Section" value={Section}
                                    required onChange={handleSectionChange} >
                                    <option value="">Select Section</option>
                                    {items.section?.split(",").map((SEC)=>
                                    <option value={SEC.trim()}>{SEC.trim()}</option>
                                  )}
                                  </select>
                                  {errors.Section && (<div className="error-message"> {errors.Section} </div>)}
                                </>
                              ) : (
                                row.Section
                              )}
                            </td>

                            <td style={{ textAlign: "center" }}>
                             
                              {parseInt(row.Grade) <= 10 && (row.OptionalSubject === "" || row.OptionalSubject === null) &&
                                editingId === index + 1 ? (
                                <>
                                  <select className="form-select border-danger" name="OptionalSubject"
                                    value={OptionalSubject} required
                                    disabled={parseInt(row.Grade) > 10 || parseInt(row.Grade) < 3}
                                    onChange={handleOptionalSubjectChange} >
                                    <option value="">Select Language</option>
                                    {items.languageSubjectName.split(",").map((OL, Index) => (<option value={OL}>{OL}</option>))}
                                  </select>
                                  {errors.Language && (<div className="error-message"> {errors.Language} </div>)}
                                </>
                              )
                              
                                : (
                                  row.OptionalSubject
                                )}
                            </td>

                            <td style={{ textAlign: "center" }}>
                             

                              {parseInt(row.Grade) > 10 && (row.ElectiveSubject === "" || row.ElectiveSubject === null) &&
                                editingId === index + 1 ? (
                                <>
                                  <select className="form-select border-danger" name="ElectiveSubject"
                                    value={ElectiveSubject} required onChange={handleElectiveSubjectChange} >
                                    <option value="">Select Elective Subject</option>
                                    <option value="Biology">Biology</option>
                                    <option value="Mathematics">Mathematics</option>
                                  </select>
                                  {errors.ElectiveSubject && (<div className="error-message"> {errors.ElectiveSubject} </div>)}
                                </>
                              )
                              
                                : (
                                  row.ElectiveSubject
                                )}
                            </td>

                            <td style={{ textAlign: "center" }}>
                              {(row.MediumofInstruction === "" || row.MediumofInstruction === null || row.errors.MediumofInstruction) &&
                                editingId === index + 1 && row.errors.MediumofInstruction ? (
                                <>
                                  <select className="form-select border-danger" name="MediumofInstruction"
                                    value={MediumofInstruction} required onChange={handleMediumofInstruction} >
                                    <option value="">Select Medium</option>
                                    <option value={items?.medium}>{items?.medium}</option>
                                  </select>
                                  {errors.MediumofInstruction && (<div className="error-message"> {errors.MediumofInstruction} </div>)}
                                </>
                              ) : (
                                row.MediumofInstruction
                              )}
                            </td>
                            {items?.societyName === "NATCO" &&
                              <td>
                                {editingId === index + 1 ?
                                  <>
                                    <select className="form-select border-danger" name="MediumofInstruction"
                                      value={PSTStatus || row?.["PST Status"]} required onChange={handlePSTStatus} >
                                      <option value="">Select PST Status</option>
                                      <option value="Yes">Yes</option>
                                      <option value="No">No</option>
                                    </select>
                                    {errors.PSTStatus && (<div className="error-message"> PST Status is required </div>)}
                                  </>
                                  : row?.["PST Status"]}
                              </td>}
                            <td style={{ color: "red" }}>
                              <ol style={{listStyle:"auto"}}> {Object.values(row.errors).map((err) => (<li>{err}</li>))} </ol>
                            </td>
                            <td>
                              {editingId === index + 1 ? (
                                <>
                                  <button onClick={() => handleCancelClick(index + 1)} className="btn btn-sm btn-dark" style={{ marginRight: "6px" }} > Cancel </button>
                                  <button className="btn btn-sm btn-primary" onClick={() => handleSaveClick(index + 1)} > Save </button>
                                </>
                              ) : (
                                <>
                                  <FaTrash className="CPointer" title="Delete"
                                    onClick={() => handleDeleteRow(index + 1, "invalid")}
                                    style={{ alignItems: "left", color: "#DC4C64", marginRight: "5px", }} />

                                  {row.RecordExitsInDb === 0 ? (
                                    <FaEdit className="CPointer" title="Edit" style={{ alignItems: "left", color: "#14A44D" }}
                                      onClick={() => handleEditClick(index + 1, row.FirstName, row.LastName, row.DOB,
                                        row.Gender, row.Grade, row.Section, row.ElectiveSubject, row.MediumofInstruction,
                                        row.OptionalSubject, row.PSTStatus)}
                                    />
                                  ) : (
                                    ""
                                  )}
                                </>
                              )}
                            </td>
                          </tr>
                        </React.Fragment>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </div>
          <div className="col-md-12">
            {ValidRecords && ValidRecords.length > 0 && (
              <div className="Table-Card mt-3" style={{ overflow: "clip" }}>
                <div className="Grade-Information p-3"> Valid Records
                  {selectedValidDeleteIds && selectedValidDeleteIds.length > 0 ? (
                    <button className="btn btn-sm btn-warning"
                      onClick={() => handleDeleteRows(selectedValidDeleteIds, "valid")}
                      style={{ float: "right", marginLeft: "5px" }} > Delete selected records </button>
                  ) : (
                    ""
                  )}
                  <>
                    <button className="btn btn-sm btn-success" onClick={FinalSaveValidRecords} style={{ float: "right" }}> Save </button>
                  </>
                </div>
                <div className="table-responsive">
                  <table className="table table-bordered table-sm">
                    <thead>
                      <tr>
                        <th></th>
                        <th>S.No</th>
                        <th>First Name</th>
                        <th>Last Name</th>
                        <th>DOB</th>
                        <th>Gender</th>
                        <th>Grade</th>
                        <th>Section</th>
                        <th>Language</th>
                        <th>Elective Subject</th>
                        <th>Medium of Instruction</th>
                        {items?.societyName === "NATCO" && <th> PST Status </th>}
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {ValidRecords?.map((row, index) => (
                        <React.Fragment key={index + 1}>
                          <tr>
                            <td width={5} style={{ textAlign: "center" }}>
                              <input type="checkbox" class="form-check-input"
                                checked={selectedValidDeleteIds.includes(index + 1)}
                                onChange={() => handleValidSelectRow(index + 1)} />
                            </td>
                            <td width={5} style={{ textAlign: "center" }}> {index + 1} </td>
                            <td width={15}>{row.FirstName}</td>
                            <td width={15}>{row.LastName}</td>
                            <td width={20}>{DisplayformatDate(row.DOB)}</td>
                            <td width={15}>{row.Gender}</td>
                            <td width={10}>{row.Grade}</td>
                            <td width={5}>{row.Section}</td>
                            <td width={5}> {row.OptionalSubject !== "undefined" ? row.OptionalSubject : null} </td>
                            <td width={5}> {row.ElectiveSubject !== "undefined" ? row.ElectiveSubject : null} </td>
                            <td width={5}> {row.MediumofInstruction !== "undefined" ? row.MediumofInstruction : null} </td>
                            {items?.societyName === "NATCO" && <td width={5}> {row.PSTStatus} </td>}
                            <td width={5}>
                              <FaTrash className="CPointer" onClick={() => handleDeleteRow(index + 1, "valid")}
                                style={{ alignItems: "left", color: "#DC4C64", }} title="Delete" />
                            </td>
                          </tr>
                        </React.Fragment>
                      ))}
                      <tr style={{ border: "0px" }}>
                        <td colSpan={4} style={{ border: "0px" }}></td>
                        <td style={{ border: "0px", paddingTop: "10px" }}>

                          <>
                            <button className="btn btn-lg btn-success"
                              onClick={FinalSaveValidRecords} > Save</button>
                          </>
                        </td>
                        <td colSpan={4} style={{ border: "0px" }}></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      {Load && <Loading />}
    </>
  );
};
export default AutobulkRegistrations;